<template>
    <v-dialog width="700px" v-model="dialog" >

        <template v-slot:activator="{ on }" color="primary">
            <v-btn
                    small
                    id="editModal"
                    class="float-right"
                    color="primary"
                    depressed
                    v-on="on"
            ><v-icon left>mdi-pencil</v-icon>Edit Area
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                <span class="headline">Edit Area</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form"

                    >
                        <v-row>
                            <v-col cols="12" sm="12" class="area-select">
                                <v-autocomplete
                                    outlined
                                    label="Please Select From a City*"
                                    required
                                    v-model="city_id"
                                    item-text="city_name"
                                    item-value="id"
                                    :items="citiesList"
                                    :error-messages="selectErrors"
                                    @blur="$v.city_id.$touch()"
                                    dense
                                    solo
                                    clearable
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="data"
                                    >
                                        <div>
                                            <div v-html="data.item.city_name" />
                                        </div>
                                    </template>
                                    <template
                                        slot="item"
                                        slot-scope="data"
                                    >
                                        <!-- Divider and Header-->
                                        <template v-if="typeof data.item !== 'object'">
                                            <div v-text="data.item"/>
                                        </template>
                                        <template>
                                            <div class="select-drop-item-city">
                                            <div v-html="data.item.city_name" />
                                            </div>
                                        </template>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Area Name*"
                                        hint="enter area name"
                                        required
                                        v-model="name"
                                        :error-messages="nameErrors"
                                        @input="$v.name.$touch()"
                                        @blur="$v.name.$touch()"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <!--<span class="adjustment-type">Standard Pay (Per Hour)*</span>-->
                                <!--<span class="adjustment">$200</span>-->
                                <div class="adjustment area-modal">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            prefix="£"
                                            type="number"
                                            outlined
                                            label="Standard Pay (Per Hour)*"
                                            class="adjustment-input"
                                            placeholder="0.00"
                                            required
                                            v-model="standardPayRate"
                                            :error-messages="standardPayRateErrors"
                                            @input="$v.standardPayRate.$touch()"
                                            @blur="$v.standardPayRate.$touch()"
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <!--<span class="adjustment-type">Standard Pay (Per Hour)*</span>-->
                                <!--<span class="adjustment">$200</span>-->
                                <div class="adjustment area-modal">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            prefix="£"
                                            type="number"
                                            outlined
                                            label="Weekend Pay (Per Hour)*"
                                            class="adjustment-input"
                                            placeholder="0.00"
                                            required
                                            v-model="weekendPayRate"
                                            :error-messages="weekendPayRateErrors"
                                            @input="$v.weekendPayRate.$touch()"
                                            @blur="$v.weekendPayRate.$touch()"
                                    ></v-text-field>
                                </div>
                            </v-col>

                        </v-row>

                        <div class="d-flex justify-center">
                            <v-btn
                                    color="primary"
                                    depressed
                                    class="mr-4"
                                    :disabled="this.$v.$invalid || localLoading"
                                    @click="submit"
                                    :loading="localLoading"
                            ><v-icon left>mdi-check-box-outline</v-icon>Accept Changes</v-btn>
                            <v-btn
                                    color="warning"
                                    depressed
                                    @click="cancel"
                                    :loading="localLoading"
                            ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                        </div>

                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required,/* maxLength, email, numeric*/ } from 'vuelidate/lib/validators'
    import {mapGetters} from 'vuex'

    export default {
        props: ['thisAreaData', 'editArea'],
        mixins: [validationMixin],
        name: "EditAreaModal",

        validations: {
            name: { required },
            city_id: { required },
            standardPayRate: { required },
            weekendPayRate: { required },
        },
        data: () => ({
            areaData: null,
            localLoading: false,
            id: '',
            name: '',
            city_id: null,
            dialog: false,
            standardPayRate: '',
            weekendPayRate: ''
        }),
        created(){
            this.areaData = this.thisAreaData
            this.id = this.areaData.id
            this.name = this.areaData.name
            this.city_id = +this.areaData.city_id
            this.standardPayRate = this.areaData.standardPayRate
            this.weekendPayRate = this.areaData.weekendPayRate
        },

        computed: {
            ...mapGetters([
                'cities',
                'areas',
            ]),
            loading(){
                return this.$store.getters.loading
            },
            selectErrors () {
                const errors = []
                if (!this.$v.city_id.$dirty) return errors
                !this.$v.city_id.required && errors.push('City is required')
                return errors
            },
            nameErrors () {
                const errors = []
                if (!this.$v.name.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.name.required && errors.push('Area name is required.')
                return errors
            },
            standardPayRateErrors () {
                const errors = []
                if (!this.$v.standardPayRate.$dirty) return errors
                /*!this.$v.standardPayRate.numeric && errors.push('Must be numeric')*/
                !this.$v.standardPayRate.required && errors.push('Pay rate is required')
                return errors
            },
            weekendPayRateErrors () {
                const errors = []
                if (!this.$v.weekendPayRate.$dirty) return errors
                /*!this.$v.weekendPayRate.numeric && errors.push('Must be numeric')*/
                !this.$v.weekendPayRate.required && errors.push('Pay rate is required')
                return errors
            },
            citiesList() {
                return this.cities;
            }
        },

        methods: {
            cancel(){
                this.dialog = false
                this.areaData = this.thisAreaData
                this.name = this.areaData.name
                this.city_id = this.areaData.city_id
                this.standardPayRate = this.areaData.standardPayRate
                this.weekendPayRate = this.areaData.weekendPayRate

                this.dialog = false;
            },
            submit () {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    const editedArea = {
                        name: this.name,
                        standardPayRate: this.standardPayRate,
                        weekendPayRate: this.weekendPayRate,
                        id: this.id,
                        city_id: this.city_id,
                        restaurantsAssigned: this.areaData.restaurantsAssigned
                    };

                    this.localLoading = true
                    this.$store.dispatch('editArea', editedArea).then(() => {
                        this.dialog = false;
                    }).finally(() => {
                        this.localLoading = false;
                    });
                }
            },
        },
    }
</script>

<style scoped>

</style>